import React from 'react';
import styled from '@emotion/styled';

interface IImg {
  src: string;
  alt?: string;
  className?: string;
}
const Img: React.FC<IImg> = ({ src, alt, className }) => {
  return (
    <StyledImg
      loading="lazy"
      src={src}
      alt={alt}
      decoding="async"
      className={className}
    />
  );
};

export default Img;

const StyledImg = styled.img`
  &.responsive {
    width: 100%;
    height: auto;
    object-fit: cover;
  }

  &.trans {
    opacity: 40%;
  }
`;
